<template>
  <div class="time-slot-message">
    <div class="avatar">
      <img src="@/assets/images/robot.png" class="avatar-img" alt="AI" />
    </div>
    <div class="message-body">
      <div class="sender-name">智能助手</div>
      <div class="bubble">
        <div class="content" v-if="msg.content">{{ msg.content }}</div>
        <div class="loading-tips" v-if="msg.loadingSlots">加载中...</div>
        <div class="slot-grid">
          <button
            v-for="(slot, idx) in msg.options"
            :key="idx"
            type="button"
            class="slot-btn"
            :class="{ selected: isSlotSelected(slot) }"
            :disabled="isSlotDisabled(slot)"
            @click="selectSlot(slot)"
          >
            <div class="slot-text">{{ slotText(slot) }}</div>
          </button>
        </div>
        <div class="bubble-footer" v-if="msg.time">
          <div class="time">{{ msg.time }}</div>
        </div>
      </div>
      <div class="progress" v-if="msg.progress">{{ msg.progress }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeSlotMessage',
  props: {
    msg: { type: Object, required: true },
    index: { type: Number, default: 0 },
  },
  methods: {
    slotText(slot) {
      if (slot && typeof slot === 'object') return slot.text || slot.value || '';
      return slot;
    },
    slotKey(slot) {
      if (slot && typeof slot === 'object') return slot.value || slot.text || JSON.stringify(slot);
      return slot;
    },
    getSlotStats(slot) {
      if (!this.msg.timeSlotStats) return null;
      return this.msg.timeSlotStats[this.slotKey(slot)];
    },
    getSlotRemaining(slot) {
      const stats = this.getSlotStats(slot);
      if (!stats) return '';
      return `余 ${stats.remaining || 0}`;
    },
    isSlotFull(slot) {
      const stats = this.getSlotStats(slot);
      return stats && (stats.remaining === 0 || stats.remaining === '0');
    },
    isSlotSelected(slot) {
      if (!this.msg.selectedSlotValue) return false;
      return String(this.slotKey(slot)) === String(this.msg.selectedSlotValue);
    },
    isSlotDisabled(slot) {
      return this.msg.verified || this.isSlotFull(slot);
    },
    selectSlot(slot) {
      // 弹确认框，让用户确认所选时间段
      const text = this.slotText(slot);
      this.$emit('slot-confirm', { slot, text });
    },
  },
};
</script>

<style lang="scss" scoped>
.time-slot-message {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}
.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  flex-shrink: 0;
  background: #e8f8ff;
}
.avatar-img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
}
.message-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.bubble {
  display: inline-block;
  max-width: 75%;
  margin: 0 30px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #fff;
  font-size: 14px;
  line-height: 1.5;
  color: #333;
}
.sender-name {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
  margin-left: 30px;
}
.content {
  white-space: pre-line;
}
.loading-tips {
  font-size: 12px;
  color: #999;
  margin-top: 10px;
}
.slot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-top: 10px;
}
.slot-btn {
  /* 白底灰框，不要 vant 默认的蓝/绿色 */
  appearance: none;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  color: #333;
  line-height: 1.2;
  padding: 14px 8px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
  -webkit-tap-highlight-color: transparent;
}
.slot-btn:hover {
  border-color: #c0c4cc;
  background: #f7f8fa;
}
.slot-btn:active {
  /* 点击瞬间深灰效果 */
  background: #5b6168;
  border-color: #5b6168;
  color: #ffffff;
}
.slot-btn:disabled {
  background: #f5f5f5;
  border-color: #ebeef5;
  color: #c0c4cc;
  cursor: not-allowed;
}
/* 用户已选中的时间段：黑底白字高亮 */
.slot-btn.selected,
.slot-btn.selected:disabled {
  background: #666666;
  border-color: #666666;
  color: #ffffff;
}
.slot-text {
  /* 时间段必须一行显示，手机窄屏放不下时缩小字号也不换行 */
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
}
.bubble-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  min-height: 18px;
}
.bubble-footer .time {
  font-size: 12px;
  color: #999;
}
.progress {
  font-size: 12px;
  color: #999;
  margin: 4px 30px 0;
}
</style>